export const blockIconsAudioandvideoMovie = (
	<span className='material-symbols-outlined'>movie</span>
);
